import { useService } from '@nzyme/vue-ioc/useService.js';
import { onEventEmitter } from '@nzyme/vue-utils/onEventEmitter.js';
import { ActorConnectionService } from '../services/ActorConnectionService.js';
import { ChatStore } from './ChatStore.js';
/**
 * View-scoped composable that wraps ChatStore.
 * Accepts a static chat ID — the component must be re-mounted for a different chat.
 * Auto-refreshes the chat on reconnect, scoped to the component lifecycle.
 */
export function useChat(chatId) {
    const chatStore = useService(ChatStore);
    const actorConnection = useService(ActorConnectionService);
    const chat = chatStore.getChat(chatId);
    onEventEmitter(actorConnection.events.connected, () => {
        // Only refresh when stale (i.e. after a prior disconnect). The initial
        // load is the caller's responsibility; refreshing here would race with
        // it and trigger a duplicate ChatLoad call on first mount.
        if (chat.stale) {
            void chatStore.refreshChat(chatId);
        }
    });
    return chat;
}
//# sourceMappingURL=useChat.js.map